export default "skymp5-front/26afe2d05dbcb03bcc2e1492989a5783.png";